import { Box, Divider, Typography } from '@mui/material'

interface LayoverBlockProps {
    prefix: {
        layover: string
        in: string
    }
    layoverType: string
    layoverDuration: string
    layoverText: string
}

const LayoverBlock = ({ prefix, layoverDuration, layoverText }: LayoverBlockProps) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                my: 2
            }}
        >
            {/* Left Divider */}
            <Divider
                sx={{
                    flex: 1,
                    borderColor: 'borders.default'
                    // borderWidth: 1
                }}
            />

            {/* Center Content */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    borderRadius: '20px',
                    fontSize: '12px',
                    px: 1,
                    py: 0.5,
                    justifyContent: 'center',
                    // flexShrink: 0,
                    border: 'solid 1px',
                    borderColor: 'borders.default'
                }}
            >
                <Box>
                    <Typography
                        sx={{
                            fontWeight: 700,
                            color: 'link.main',
                            fontSize: 10,
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        {prefix.layover}
                        <Typography component="span" sx={{ fontSize: 14, color: 'textColors.subtitle', mx: 0.3 }}>
                            •
                        </Typography>
                        <Typography
                            component="span"
                            sx={{
                                fontSize: 10,
                                fontWeight: 700,
                                color: 'textColors.subtitle',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            {layoverDuration} {prefix.in} {layoverText}
                        </Typography>
                    </Typography>
                </Box>
            </Box>

            {/* Right Divider */}
            <Divider
                sx={{
                    flex: 1,
                    borderColor: 'borders.default'
                    // borderWidth: 1
                }}
            />
        </Box>
    )
}

export default LayoverBlock
